<template>
  <div :class="Loading ? 'disable border rounded mt-2' : 'border rounded mt-2'" style="position: relative;">
    <table class="table table-sm table-hover w-100">
      <thead>
        <tr>
          <td class="text-center" :style="{ 'vertical-align': 'inherit' }">
            Shipping
          </td>
          <td class="text-center">
            <button :disabled="isDisabled" @click="fetchShippingDetail()" class="btn btn-success">Fetch Shipping<i class="fas fa-spinner fa-spin" v-if="isDisabled"></i></button>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="2">
            <div class="button-tray d-flex" style="flex-wrap: wrap;">
              <button
                url="https://www.fedex.com/apps/pagenotfound/404.shtml?action=track&language=english&cntry_code=us&mps=y&ascend_header=1&imageField=Track&tracknumbers="
                class="btn btn-primary mr-1 mb-1"
                @click="(e) => openLink(e)"
              >
                Fed Ex
              </button>
              <button
                url="https://wwwapps.ups.com/WebTracking/track?HTMLVersion=5.0&loc=en_US&Requester=UPSHome&track.x=Track&WBPM_lid=&trackNums="
                class="btn btn-primary mr-1 mb-1"
                @click="(e) => openLink(e)"
              >
                UPS
              </button>
              <button url="http://track.dhl-usa.com/TrackByNbr.asp" class="btn btn-primary mr-1 mb-1" @click="(e) => openLink(e)">
                Airborne
              </button>
              <button
                url="https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum="
                class="btn btn-primary mr-1 mb-1"
                @click="(e) => openLink(e)"
              >
                USPS
              </button>
              <button url="https://webtrack.dhlglobalmail.com/?trackingnumber=" class="btn btn-primary mr-1 mb-1" @click="(e) => openLink(e)">
                DHL
              </button>
              <button url="https://www2.lso.com/access/trackingresult.aspx?airbillnos=" class="btn btn-primary mr-1 mb-1" @click="(e) => openLink(e)">
                Lone Star
              </button>
              <button
                url="https://www.ontrac.com/trackingresults.asp?x=15&y=15&tracking_number="
                class="btn btn-primary mr-1 mb-1"
                @click="(e) => openLink(e)"
              >
                OnTrac
              </button>
              <button
                url="https://my.yrc.com/tools/track/shipments?referenceNumber=&referenceNumberType=PRO"
                class="btn btn-primary mr-1 mb-1"
                @click="(e) => openLink(e)"
              >
                YRC
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Carrier:</strong>
          </td>
          <td class="text-left w-65">
            <select name="carrier" class="form-control input-sm" v-model="order.carrierName">
              <option value="-1">Select a carrier</option>
              <option value="Fed Ex">Fed Ex</option>
              <option value="UPS">UPS</option>
              <option value="USPS">USPS</option>
              <option value="Airborne">Airborne</option>
              <option value="DHL ">DHL</option>
              <option value="Lone Star">Lone Star</option>
              <option value="OnTrac">OnTrac</option>
              <option value="YRC">YRC</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Track number:</strong>
          </td>
          <td class="text-left w-65">
            <input class="form-control" type="text" name="" id="" v-model="order.trackingNumber" />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Date & time shipped:</strong>
          </td>
          <td class="text-left w-50">
            <!-- <input
              class="form-control"
              type="datetime-local"
              step="1"
              name=""
              id=""
              v-model="order.dateShipped"
            /> -->
            <a-date-picker
              show-time
              style="width: 100%;"
              format="MM/DD/YYYY hh:mm:ss"
              :value="order.dateShipped"
              @change="updateDateShipped"
              id="dateFrom"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Estimated Delivery Date:</strong>
          </td>
          <td class="text-left w-50">
            <span>{{ order.dateProcessed }}</span>
          </td>
        </tr>
        <!-- <tr>
        <td class="text-right w-35">
          <strong>Ship time:</strong>
        </td>
        <td class="text-left w-65">
          <input class="form-control" type="text" name="" id="" />
        </td>
      </tr> -->
        <tr>
          <td class="text-right w-35">
            <strong>Quality #:</strong>
          </td>
          <td class="text-left w-65">
            <input class="form-control" type="text" name="" id="" v-model="order.qualityNum" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <button type="button" style="display: block; margin: 0 auto;" class="btn btn-primary" @click="submit">
              Update Shipping
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="centered-spinner" v-if="Loading">
      <a-spin />
    </div>
  </div>
</template>

<script>
import { UTCToLocale, localeToUTC } from '@/utilities/date.js';
import moment from 'moment';
import FrontendService from "../../../../../../services/FrontendService"
export default {
  name: 'Shipping',
  data() {
    return {
      Loading: false,
      isDisabled: false,
    };
  },
  methods: {
    updateDateShipped(date, datestring) {
      this.order.dateShipped = datestring;
    },
    openLink(e) {
      let url = e.target.getAttribute('url');
      window.open(url, '_blank');
    },
    submit() {
      if (this.order.dateShipped === '' || this.order.dateShipped === null) {
        this.$error({
          content: 'Date & time shipped: is required',
        });
        return;
      }
      this.Loading = true;
      const shippingRequest = {
        carrier: this.order.carrierName === '-1' ? '' : this.order.carrierName,
        tracking_number: this.order.trackingNumber,
        date_shipped: this.order.dateShipped === '' || this.order.dateShipped === null ? '' : localeToUTC(this.order.dateShipped),
        quality_number: this.order.qualityNum,
        order_id: this.order.orderId,
      };
      this.$store.commit('orderDetails/SET_SHIPPING_REQUEST', shippingRequest);
      this.$store
        .dispatch('orderDetails/updateShipping', shippingRequest)
        .then((data) => {
          alert(data);
        })
        .finally(() => {
          this.Loading = false;
        });
    },
    fetchShippingDetail() {
      this.isDisabled = true;
      this.Loading = true;
      //let data = { bestBuyOrderId: 'BBY01-806795143431' };
      let data = { bestBuyOrderId: this.order.bestBuyOrderId };
      FrontendService.fetchShippingDetail(data)
        .then((response) => {
          this.isDisabled = false;
          this.Loading = false;
          alert(response.data.responseMessage);
          if (response.status != 400) {
            window.location.reload();
          }
        }).catch((e) => {
          this.isDisabled = false;
          this.Loading = false;
          alert(e.response.data.responseMessage);
        });
    }
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.w-35 {
  width: 35%;
}
.w-65 {
  width: 65%;
}
.w-50 {
  max-width: 0px !important;
}
.centered-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
table {
  margin-bottom: 0px;
  border: solid grey 0.5px;
}
td {
  border: solid grey 0.5px;
}
</style>
